import { GetEvaluationQuery } from '@/api/queries';

export namespace TrainingChecklistTableTypes {
  // Derived from the GetEvaluation operation's own selection set (not the raw schema model) -
  // the query only selects the handful of snapshot fields this feature needs.
  export type EvaluationDetail = NonNullable<GetEvaluationQuery['getEvaluation']['evaluation']>;
  export type CategoryWithQuestions = EvaluationDetail['categories'][number];
  export type EvaluationQuestion = CategoryWithQuestions['questions'][number];
  export type EvaluationQuestionSnapshot = EvaluationQuestion['question'];
  export type EvaluationAnswerOptionSnapshot = EvaluationQuestion['options'][number];

  export enum CategoryStatus {
    PENDING = 'PENDING',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
  }

  export type ChecklistItem = {
    id: string;
    name: string;
    sortOrder: number;
    status: CategoryStatus;
    // "First Last" resolved server-side (SKYP-9863) from the category's submittedBy;
    // null/undefined when the category is unsubmitted or the submitting user can't be resolved.
    trainerFullName?: string | null;
    canEvaluate: boolean;
  };

  export type ChecklistState = {
    rows: ChecklistItem[];
    categoryWithQuestionMap: Record<string, CategoryWithQuestions>;
  };
}
